import AddCommentIcon from '@mui/icons-material/AddComment';
import { useTheme } from '@mui/material';

export const More = () => {
  const theme = useTheme();

  return (
    <AddCommentIcon
      fontSize="large"
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
